/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

export const GLOBAL_NAV_SLICE_NAME = 'globalNav'
